import React from 'react';
import { cn } from '@/src/infrastructure/lib/utils';
import type { FeedbackStatus } from '@/src/infrastructure/lib/api';
import { STATUS_LABEL, STATUS_TONE } from './constants';

/** Pill-shaped status indicator used across list + detail pages. */
export function FeedbackStatusBadge({
  status,
  className,
}: {
  status: FeedbackStatus;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold uppercase tracking-wide',
        STATUS_TONE[status],
        className,
      )}
      aria-label={`Status: ${STATUS_LABEL[status]}`}
    >
      {STATUS_LABEL[status]}
    </span>
  );
}
